import { z } from 'zod';

import { zodSuccessResponseSchema } from '@vestigas/data';

export const zodAdditionalNoteRequestSchema = z.object({
  note: z.string().min(1).max(10_000),
});

export const zodAdditionalNoteResponseSchema = z.object({
  createdBy: z.record(z.string(), z.unknown()),
  createdOn: z.iso.datetime({ offset: true }),
  id: z.uuid(),
  modifiedBy: z.record(z.string(), z.unknown()).nullable().optional(),
  modifiedOn: z.iso.datetime({ offset: true }).nullable().optional(),
  note: z.string(),
});

export { zodSuccessResponseSchema };
